import { useTranslation } from "react-i18next"
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import { ViewMode } from "@/modules/admin/sasis-lookup/types/lookup-result-entry"

type ViewModeToggleProps = {
  viewMode: ViewMode
  onViewModeChange: (viewMode: ViewMode) => void
}

export const ViewModeToggle = ({ viewMode, onViewModeChange }: ViewModeToggleProps) => {
  const { t } = useTranslation()

  const handleValueChange = (value: string) => {
    if (value === "mapped" || value === "raw") {
      onViewModeChange(value)
    }
  }

  return (
    <ToggleGroup type="single" value={viewMode} onValueChange={handleValueChange} data-testid="sasis-view-mode-toggle">
      <ToggleGroupItem value="mapped" data-testid="toggle-mapped">
        {t("admin.sasisLookup.mapped")}
      </ToggleGroupItem>
      <ToggleGroupItem value="raw" data-testid="toggle-raw">
        {t("admin.sasisLookup.raw")}
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
